<app-top-bar [showViewerControls]="false"></app-top-bar>
